// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3MHeB","consentsList":"PatientConsents_consentsList__3kM3q","consentsListEmpty":"PatientConsents_consentsListEmpty__2WwIx"};